import React, { useEffect, useRef, useState } from 'react';
import { usePageMeta } from '../components/shared/SEO';
import { MateriaisCipe } from '../components/tools/MateriaisCipe';

const TOOL_SRC = '/ferramentas/compare-seu-plantao.html?v=2';
const HEADER_PX = 80;

const CalculadoraPlantao = () => {
  const iframeRef = useRef(null);
  const [height, setHeight] = useState(`calc(100vh - ${HEADER_PX}px)`);

  usePageMeta({
    title: 'Quanto vale o seu plantão de cirurgia pediátrica | Apex Medical Hub',
    description: 'Compare o valor do seu plantão com 118 plantões declarados por 102 cirurgiões pediátricos de 24 estados. Ferramenta gratuita da Apex Medical Hub.',
    canonical: '/calculadora-plantao',
    image: '/og/cipe.jpg',
  });

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return undefined;
    let timer;
    const ajustar = () => {
      try {
        const doc = iframe.contentDocument;
        const h = doc?.documentElement?.scrollHeight || doc?.body?.scrollHeight;
        if (h && h > 200) setHeight(`${h}px`);
      } catch {
        // cross-origin: mantém altura da viewport
      }
    };
    const onLoad = () => {
      ajustar();
      timer = setInterval(ajustar, 500);
    };
    iframe.addEventListener('load', onLoad);
    return () => {
      iframe.removeEventListener('load', onLoad);
      if (timer) clearInterval(timer);
    };
  }, []);

  return (
    <div className="w-full bg-[#f3f7fa]" data-testid="calculadora-plantao-page">
      <iframe
        ref={iframeRef}
        src={TOOL_SRC}
        title="Compare o seu plantão"
        style={{ width: '100%', height, border: 'none', display: 'block' }}
        loading="eager"
        data-testid="calculadora-plantao-iframe"
      />
      <MateriaisCipe />
    </div>
  );
};

export default CalculadoraPlantao;
